import type React from 'react';
import { IconComponent } from '@/components/IconComponent';
import { ScArrowButton } from './styled';

interface IArrowButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  isOpen: boolean;
}

export const ArrowButton = ({
  children,
  onClick,
  isOpen,
}: IArrowButtonProps) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <ScArrowButton isOpen={isOpen} onClick={handleClick}>
      {children}
      <span className="arrow-icon">
        <IconComponent name="whiteArrowRight" size="18px" />
      </span>
    </ScArrowButton>
  );
};
